export interface ReviewData {
  productId?: string;
  shopId?: string;
  rating: number;
  comment: string;
  images?: string[];
  customerId: string;
  customerName: string;
  customerAvatar?: string;
}

export interface ReviewSortOption {
  value: 'newest' | 'highest' | 'lowest' | 'helpful';
  label: string;
}

export const REVIEW_SORT_OPTIONS: ReviewSortOption[] = [
  { value: 'newest', label: 'Más recientes' },
  { value: 'highest', label: 'Mejor calificadas' },
  { value: 'lowest', label: 'Peor calificadas' },
  { value: 'helpful', label: 'Más útiles' },
];

export type ReportReason = 'fake' | 'inappropriate' | 'off_topic' | 'spam' | 'other';

export const REPORT_REASONS: { value: ReportReason; label: string }[] = [
  { value: 'fake', label: 'Reseña falsa o engañosa' },
  { value: 'inappropriate', label: 'Contenido inapropiado' },
  { value: 'off_topic', label: 'No está relacionado con el producto' },
  { value: 'spam', label: 'Spam' },
  { value: 'other', label: 'Otro motivo' },
];
